import react, { useEffect, useState } from "react";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../../AbstractElements";
import RouteDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import {
  useAddBeatOutlet,
  useAddOutletOrgNote,
  useBeatOutletByID,
  useBeatOutletStatus,
  useOutletOrgNoteByID,
  useUpdateBeatOutlet,
  useUpdateOutletOrgNote,
} from "../hooks/useCustomer";
import PaginatedRouteDropdown from "../../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getTownFilter } from "../hooks/CustomerRepository";
import { getBeats } from "../../../FSM/Beats_Patches/hooks/BeatRepository";

interface prop {
  mode: "add" | "edit";
  modalClose: () => void;
  initialData?: Record<string, any>;
  OutletOrgId: any;
  customerId?:any
}

const BeatOutletModal: React.FC<prop> = ({
  mode,
  modalClose,
  initialData,
  OutletOrgId,
  customerId
}) => {
  const [status, setStatus] = useState<any>();
  const [reportEndDate, setReportEndDate] = useState<string | undefined>();
  const [selectedBeat, setSelectedBeat] = useState<{
      id: number;
      label: string;
    } | null>(null);

  console.log("outletOrgDataId", OutletOrgId);

const {data:getBeatOutlet}=useBeatOutletByID({
  enabled:mode=='edit',
  params:{
    beatOutletMapId:initialData?.BeatOutletMapid
  }
})

  const { data: BeatOutletStatus } = useBeatOutletStatus({
    enabled: mode=='edit',
  });

  const FormattedBeatStatus = Object.keys(BeatOutletStatus?.data || {}).map(
    (status: any) => ({
      id: status,
      label: BeatOutletStatus?.data[status],
    })
  );

  useEffect(() => {
    if (mode === "edit" && getBeatOutlet?.data?.BeatOutletData) {
      const data = getBeatOutlet?.data?.BeatOutletData;

          let formattedDate = "";
    if (data?.ReportEndDate) {
      const [day, month, year] = data.ReportEndDate.split("-");
      formattedDate = `${year}-${month}-${day}`; // Convert to YYYY-MM-DD
    }

      setReportEndDate(formattedDate);
      setStatus(data?.Status || "");
      setSelectedBeat({
        id:data?.BeatId ,
      label:data?.BeatName});
    }

  }, [getBeatOutlet, mode]);

  const { mutate: addBeatOutlet } = useAddBeatOutlet();
  const { mutate: updateBeatOutlet } = useUpdateBeatOutlet();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();


    const payload: any = {
      beatId: selectedBeat?.id,
      reportEndDate: reportEndDate,
      outletOrgDataId:OutletOrgId
      // note:note
    };
    // console.log('payload',payload)
    if (mode === "edit") {
      payload.beatOutletMapId = initialData?.BeatOutletMapid;
      payload.status=status;
      updateBeatOutlet(
        {

          body: payload,
        },
        {
          onSuccess: () => modalClose(),
          onError: (err) => {
            console.error(err);
          },
        }
      );
    } else {
      addBeatOutlet(
        {
          body: payload,
        },
        {
          onSuccess: () => modalClose(),
          onError: (err) => {
            console.error(err);
          },
        }
      );
    }
  };

  console.log('dateee',reportEndDate)

  return (
    <form onSubmit={handleSubmit}>
      <div className="container-fluid">
        <div className="col">
          <PaginatedRouteDropdown
            DropdownHeading="Beats"
            initialSelectedOptions={selectedBeat}
            onChange={(val: any) => {
              // ✅ You must get { id, label } back (see fix below in component)
              setSelectedBeat(val);
            }}
            fetchOptions={async (page: number, searchText?: string) => {
              const res = await getBeats({
                search: searchText || "",
                page,
                limit: 10,
              });
              // Assuming res is an array of beats, map them to OptionType { id, label }
              // Adjust the mapping as per your actual data structure
              console.log("response", res?.data?.data);
              const options = (res?.data?.data || []).map((beat: any) => ({
                id: beat.BeatId,
                label: beat.BeatName,
              }));
              return options;
            }}
          />
        </div>

        <div className="col">
          <label style={{ fontWeight: "500", marginTop: "8px" }}>
            Report End Date
          </label>
          <input
            type="date"
            className="form-control"
            placeholder="Enter Report End Date"
            value={reportEndDate}
            onChange={(e: any) => setReportEndDate(e.target.value)}
          />
        </div>
{mode=="edit" &&
        <div className="col">
          <RouteDropdown
            options={FormattedBeatStatus || []}
            value={status}
            onChange={(value: any) => {
              setStatus(value);
            }}
            DropdownHeading="Beat Status"
            placeholder="Select Beat Status"
          />
        </div>
}

        {/* Buttons */}
        <div className="d-flex justify-content-start gap-2 mt-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
          >
            {mode === "add" ? "Submit" : "Update"}
          </Btn>
          <Btn
            type="button"
            onClick={modalClose}
            style={{ backgroundColor: "#F9FAFC", color: "#000" }}
          >
            Cancel
          </Btn>
        </div>
      </div>
    </form>
  );
};

export default BeatOutletModal;
